import { DateTime } from 'luxon'

let clockHasAppeared = false

function revealClock () {
  if (clockHasAppeared) return

  clockHasAppeared = true
  var clockIcon = document.getElementById('clockIcon')
  var clockFade = clockIcon.animate(
    [{opacity: 0}, {opacity: 1}],
    {duration: 600, easing: 'ease', fill: 'forwards'}
  )
  clockFade.finished.then(function () {
    clockIcon.style.opacity = '1'
    clockFade.cancel()
  })
}

function numberWord (number, zero) {
  number = parseInt(number, 10)
  var map = {0: zero, 1: 'one', 2: 'two', 3: 'three', 4: 'four', 5: 'five', 6: 'six', 7: 'seven', 8: 'eight', 9: 'nine', 10: 'ten', 11: 'eleven', 12: 'twelve', 13: 'thirteen', 14: 'fourteen', 15: 'fifteen', 16: 'sixteen', 17: 'seventeen', 18: 'eighteen', 19: 'nineteen'}
  var tenMap = {2: 'twenty', 3: 'thirty', 4: 'fourty', 5: 'fifty', 6: 'sixty', 7: 'seventy', 8: 'eighty', 9: 'ninety'}
  if (number in map) {
    return map[number]
  }
  var digits = number.toString()
  var ones = numberWord(digits[digits.length - 1], '')
  var tensDigit = parseInt(digits[digits.length - 2], 10)
  var output = tenMap[tensDigit] || ''
  if (ones) {
    output += ' ' + ones
  }
  return output
}

function updateTime () {
  var now = DateTime.local().setZone('Pacific/Auckland')
  var hour = (parseFloat(window.timeRange.value) + now.hour + now.minute / 60 + now.second / 3600) % 24
  var offset = parseFloat(window.timeRange.value)
  now = now.plus({hours: offset})

  // Update clock hands using CSS variables
  var hourAngle = (now.hour % 12) * 30 + now.minute * 0.5 // 30 degrees per hour, 0.5 degrees per minute
  var minuteAngle = now.minute * 6 // 6 degrees per minute
  var secondAngle = now.second * 6 // 6 degrees per second

  // Set CSS variables on the clock icon
  var clockIcon = document.getElementById('clockIcon')
  clockIcon.style.setProperty('--hour-angle', hourAngle + 'deg')
  clockIcon.style.setProperty('--minute-angle', minuteAngle + 'deg')
  clockIcon.style.setProperty('--second-angle', secondAngle + 'deg')

  // Position the clock icon over the slider thumb
  var sliderRect = window.timeRange.getBoundingClientRect()
  var value = parseFloat(window.timeRange.value)
  var min = parseFloat(window.timeRange.min)
  var max = parseFloat(window.timeRange.max)
  var percent = (value - min) / (max - min)

  // Calculate thumb position (accounting for thumb width)
  var thumbWidth = 24
  var trackWidth = sliderRect.width - thumbWidth
  // Center clock on thumb (using larger clock size so it overlaps border)
  var thumbLeft = window.scrollX + sliderRect.left + (trackWidth * percent) + (thumbWidth / 2) - 13
  var thumbTop = window.scrollY + sliderRect.top + (sliderRect.height / 2) - 13

  clockIcon.style.left = thumbLeft + 'px'
  clockIcon.style.top = thumbTop + 'px'
  if (clockHasAppeared) {
    clockIcon.style.opacity = '1'
  }
  if (offset === 0) {
    window.time.innerHTML = "It's "
  } else {
    var formattedOffset = Math.abs(offset) + ' ' + ((Math.abs(offset) === 1) ? 'hour' : 'hours')
    if (offset > 0) {
      window.time.innerHTML = 'In ' + formattedOffset + " it'll be "
    } else {
      window.time.innerHTML = formattedOffset + ' ago it was '
    }
  }
  var closestHour = now.plus({minutes: 30})
  if (closestHour.minute < 15) {
    window.time.innerHTML += ' coming up to '
  } else if (closestHour.minute < 30) {
    window.time.innerHTML += ' nearly '
  } else if (closestHour.minute < 45) {
    window.time.innerHTML += ' just past '
  } else {
    window.time.innerHTML += ' some time after '
  }
  window.time.innerHTML += '<strong title="' + now.toFormat('cccc, h:mm a') + '">' + closestHour.toFormat('ha').toLowerCase() + ' on ' + closestHour.toFormat('cccc') + '</strong>.'
  if (hour < 6) {
    hour += 24
  }
  var absoluteHour = hour % 24
  hour = hour - 6
  var day = hour < 12
  if (!day) {
    hour = hour - 12
  }
  hour = hour / 12

  var boxClass
  if (absoluteHour >= 22 || absoluteHour < 6) {
    boxClass = 'night'
  } else if (absoluteHour >= 18) {
    boxClass = 'evening'
  } else if (absoluteHour >= 12) {
    boxClass = 'afternoon'
  } else {
    boxClass = 'morning'
  }
  window.box.className = boxClass

  // window.time.innerHTML += '<br>' + parseInt(hour * 100, 10) + '% through ' + (day ? 'day' : 'night')

  window.sun.style.display = (boxClass === 'morning' || boxClass === 'afternoon') ? 'block' : 'none'
  window.moon.style.display = (boxClass === 'evening' || boxClass === 'night') ? 'block' : 'none'
  window.sun.style.top = parseInt(100 - hour * 100, 10) + '%'
  var base = Math.pow(hour, 2)
  var right = parseInt(base * 26, 10) + 3
  window.sun.style.right = right + '%'
  window.moon.style.top = parseInt(100 - hour * 100, 10) + '%'
  window.moon.style.right = right + '%'

  // Ninja shadow calculation
  var mainEl = document.getElementById('main')
  var ninjaEl = document.getElementById('ninja')

  if (boxClass === 'morning' || boxClass === 'afternoon') {
    // Get ninja dimensions
    var ninjaWidth = ninjaEl.offsetWidth
    var ninjaHeight = ninjaEl.offsetHeight

    // Set ninja dimensions as CSS vars
    mainEl.style.setProperty('--ninja-width', ninjaWidth + 'px')
    mainEl.style.setProperty('--ninja-height', ninjaHeight + 'px')

    // Shadow scales from short at sunrise to longer at sunset (quadratic)
    var scaleY = 0.5 + Math.pow(hour, 2) * 1.0 // 0.5 at sunrise, 1.5 at sunset

    // Skew changes with time of day
    var skewDeg = 80 - 90 * hour // +80 at sunrise (hour=0), -10 at sunset (hour=1)

    // Get ninja's absolute position
    var ninjaRect = ninjaEl.getBoundingClientRect()

    // Shadow positioned at ninja's top-right corner
    var shadowTop = window.scrollY + ninjaRect.top
    var shadowRight = window.innerWidth - ninjaRect.right
    if (mainEl.classList.contains('work-profile')) {
      shadowRight -= 15
    }

    // Shadow opacity - fade in from sunrise based on skew
    // When skew is very high (near 80), fade in
    var sunriseFade = Math.min(1, Math.max(0, (80 - skewDeg) / 18))
    var shadowOpacity = 0.06 * sunriseFade

    mainEl.style.setProperty('--ninja-shadow-top', shadowTop + 'px')
    mainEl.style.setProperty('--ninja-shadow-right', shadowRight + 'px')
    mainEl.style.setProperty('--ninja-shadow-skew', skewDeg + 'deg')
    mainEl.style.setProperty('--ninja-shadow-scaleY', scaleY)
    mainEl.style.setProperty('--ninja-shadow-opacity', shadowOpacity)

    // Enable transitions after first render (position is calculated)
    if (!mainEl.classList.contains('shadow-ready')) {
      requestAnimationFrame(function() {
        mainEl.classList.add('shadow-ready')
      })
    }
  } else {
    // Hide shadow during evening/night
    mainEl.style.setProperty('--ninja-shadow-opacity', '0')
  }
}
window.timeRange.addEventListener('input', updateTime)
window.addEventListener('resize', function () {
  window.clockIcon.style.transition = 'none'
  window.clockIcon.getBoundingClientRect()
  window.clockIcon.style.opacity = '0'
  requestAnimationFrame(function () {
    window.clockIcon.style.transition = ''
  })
})

function doUpdateTime () {
  updateTime()
  setTimeout(doUpdateTime, 1000) // Update every second for the second hand
}
window.timeRange.style.display = ''
doUpdateTime()
requestAnimationFrame(revealClock)

var dateWords = document.querySelectorAll('.year-word')
for (var i = 0; i < dateWords.length; i++) {
  var el = dateWords[i]
  var year = DateTime.local().setZone('Pacific/Auckland').diff(DateTime.fromISO(el.getAttribute('data-date')), 'years').years
  el.innerText = numberWord(year, 'zero')
}

// On the work profile, keep the white introduction fixed while clipping it
// against the scrolling edge of the sky. The grey copy beneath is revealed.
var fixedIntroduction = document.querySelector('.fixed-introduction')
if (fixedIntroduction) {
  var skyIntroduction = document.querySelector('#box h1')
  var fixedRole = document.querySelector('.fixed-role')
  var introRole = document.querySelector('.intro strong')
  var compactFooter = document.querySelector('.compact-profile-footer')

  function updateIntroductionClip () {
    var skyBottom = window.box.getBoundingClientRect().bottom
    compactFooter.classList.toggle('is-visible', skyBottom <= 0)
    var introductionBottom = skyIntroduction.getBoundingClientRect().bottom
    var clipBottom = Math.max(0, introductionBottom - skyBottom)
    skyIntroduction.style.setProperty('--sky-heading-clip', clipBottom + 'px')

    var roleRect = introRole.getBoundingClientRect()
    var roleProgress = Math.min(1, Math.max(0, (32 - roleRect.top) / (roleRect.height + 32)))
    fixedRole.style.setProperty('--fixed-role-opacity', roleProgress)
  }

  window.addEventListener('scroll', updateIntroductionClip, { passive: true })
  window.addEventListener('resize', updateIntroductionClip)
  updateIntroductionClip()
}
